import { Modality } from '../interfaces/api/modality';
import axios from 'axios';

export async function getModalities(): Promise<Modality[]> {
	try {
		const response = await axios.get<Modality[]>('api/modalities/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
